(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aq-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aq-hero-slider')) {
  customElements.define('aq-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.aq-hero-slider__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.toggle = this.querySelector('.aq-hero-slider__toggle');
      if (this.slides.length < 2 || !this.toggle) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
      this.index = 0;
      this.inView = true;
      this.hovered = false;
      this.querySelector('.aq-hero-slider__controls').hidden = false;
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
        this.playing = false;
        this.show(index);
      }, options));
      this.toggle.addEventListener('click', () => {
        this.playing = !this.playing;
        this.sync();
      }, options);
      this.addEventListener('focusin', event => {
        if (!this.toggle.contains(event.target)) {
          this.playing = false;
          this.sync();
        }
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('[data-slide]')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.playing = false;
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.dots[this.index].focus();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.playing = false;
        this.sync();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      this.sync();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const label = this.playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.querySelector('[data-toggle-text]').textContent = label;
      this.querySelector('.aq-hero-slider__slides').setAttribute('aria-live', this.playing ? 'off' : 'polite');
      if (this.playing && !this.hovered && this.inView && !document.hidden) {
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
